import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppComponent } from '../../app.component';
import { LoggerService, LogPage, LogType } from '../../core/services/logger.service';
import { ProfileService } from '../../core/services/profile.service';
import { WidgetHostBaseComponent } from '../../shared/widget/widgethostbase.component';

@Component({
    selector: 'app-chromeless',
    templateUrl: './chromeless.component.html',
    styleUrls: ['./chromeless.component.scss'],
    standalone: false
})
export class ChromelessComponent extends WidgetHostBaseComponent {
    public displayWidget: string = undefined;
    public theme: string = undefined;

    constructor(
        logger: LoggerService,
        profile: ProfileService,
        public app: AppComponent,
        private route: ActivatedRoute, 
        changeDetector: ChangeDetectorRef,
    ) {
        super("ChromelessComponent", profile, logger, LogType.Page, LogPage.None, changeDetector);
        app.hasChrome = false;

        this.displayWidget = undefined;
        this.theme = undefined;
        this.route.queryParamMap.
            subscribe(params => {
                if (params.get('w'))
                    this.displayWidget = params.get('w');
                //  This is so we can apply theming to match Teams - https://docs.microsoft.com/en-us/microsoftteams/platform/tabs/how-to/access-teams-context
                if (params.get('theme'))
                    this.theme = "teams-" + params.get('theme');
            });

        var body = document.getElementById('mykeBody');
        body.classList.add('chromeless', this.theme);
    }

    ngOnInit() {

    }
}
